export default __webpack_public_path__ + "locales/ro/DeleteProfileEverDialog.json?hash=cd80564c34ef3df38650b7a68c7d2b57";